<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 class="hidden-sm-and-down">Consultar de Registros</h2>
      <div class="flex-grow-1"></div>
      <!--roleUser: 1Superadmin, 2admin y 3capturista-->
      <div class="d-flex flex-row-reverse">
        <v-btn small color="primary" to="/cedulas/registrar">
          <v-icon dark>mdi-plus</v-icon>Agregar
          <div class="flex-grow-1"></div>
        </v-btn>
      </div>
    </v-card-title>

    <v-form class="mx-10" ref="form" v-model="valid" lazy-validation>
      <v-card flat>
        <v-toolbar color="grey" dark dense flat>
          <h3>Consulta de Registros</h3>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-menu
                ref="menu_inicio"
                v-model="menu_inicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="[v => !!v || 'Seleccione fecha inicial']"
                    v-model="fechas.fecha_inicio"
                    label="Fecha a Buscar"
                    prepend-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechas.fecha_inicio"
                  @change="listCedulas = []"
                  @input="menu_inicio = false"
                  locale="es-mx"
                  min="2020-05-18"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <!-- <v-col cols="12" md="6">
              <v-menu
                ref="menu_fin"
                v-model="menu_fin"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="[v => !!v || 'Seleccione fecha final']"
                    v-model="fechas.fecha_fin"
                    label="Fecha Final"
                    prepend-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fechas.fecha_fin"
                  @change="listCedulas = []"
                  @input="menu_fin = false"
                  locale="es-mx"
                  :min="fechas.fecha_inicio"
                >
                </v-date-picker>
              </v-menu>
            </v-col> -->
          </v-row>
          <v-divider></v-divider>
          <v-btn block color="primary" @click="clickSearch()" class="my-5">
            Buscar
          </v-btn>
        </v-card-text>
        <template v-if='listCedulas.length'>
          <v-card-title  style="color:#AF8936">
            <h5>RESULTADOS DE LA BUSQUEDA</h5>
            <div class="flex-grow-1"></div>
            <h5>TOTAL: {{countCedulas}}</h5>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="listCedulas"
            item-key="id"
            :items-per-page="15"
          >
            <template #item.apellido_paterno="{ item }">
              {{ item.apellido_paterno.toUpperCase() }}
              <span v-if="item.apellido_materno">
                {{ item.apellido_materno.toUpperCase() }}
              </span>
              {{ item.nombre.toUpperCase() }}
            </template>
            <template #item.email="{ item }">
              {{ item.email.toLowerCase() }}
            </template>
            <template #item.created_at="{ item }">
              {{ item.created_at }} hrs
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn color="red" fab small dark @click="pdf(item)">
                <v-icon dark >mdi-download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div class="text-right">
            <v-btn dark color="red" @click="downloadReporte()">
              <v-icon dark>mdi-adobe-acrobat</v-icon>
              Descargar en PDF
            </v-btn>
          </div>
          <br>
        </template>
      </v-card>
      <v-dialog
        hide-overlay
        v-model="loading"
        persistent
        width="400"
      >
        <v-card color="primary" dark style="padding-top: 19px;" class="text-center">
          <v-card-text>
            <b>{{ titleLoading }}</b>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-3"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-form>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      loading: false,
      titleLoading: '',
      menu_inicio: false,
      menu_fin: false,
      fechas: {
        fecha_inicio: '',
        fecha_fin: ''
      },
      headers: [
        { text: "Nombre Completo", value: "apellido_paterno",sortable: true },
        { text: 'Email', value: 'email' },
        { text: 'Fecha y hora de registro', value: 'created_at', align:'right' },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      listCedulas: [],
      countCedulas: '',
      valid: true
    }),
    computed: {
      inicial() {
        return this.fechas.fecha_inicio;
      }
    },
    watch: {
      inicial(val){
       if (val > this.fechas.fecha_fin && this.fechas.fecha_fin != '') {
         this.fechas.fecha_fin = ''
       }
      }
    },
    methods: {
      clickSearch(){
        this.$store.dispatch("LIST_REGISTROS", this.fechas.fecha_inicio)
        .then((response) => {
          this.countCedulas = response.data.cedula.length
          this.listCedulas = response.data.cedula
        })
        .catch(err => {
          console.log(err);
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      },
      downloadReporte(){
        if (this.$refs.form.validate()) {
          this.$store.dispatch("PDF_REGISTROS", this.fechas)
          .then((response) => {
            this.loading = false
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            let inicio = this.fechas.fecha_inicio
            let fin = this.fechas.fecha_fin
            link.setAttribute('download', 'Cédulas ' + inicio +' al '+ fin +'.pdf');
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: 'Error al descargar el PDF!!!',
              icon: 'error',
              timer: 1000,
            })
          });
        }
      },
      pdf(item) {
        this.loading = true
        this.titleLoading = 'Descargando PDF'
        this.$store.dispatch("PDF_CEDULA", item.id)
        .then((response) => {
          this.loading = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          let num_cedula = item.num_cedula
          let tipo = (item.tipo_cedula == 1 ? 'Estatal' : 'Federal' )
          link.setAttribute('download', 'Cédula_' + tipo +'_'+ num_cedula +'.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
          this.$router.push('/cedulas/reportes')
        });
      }
    }
  };
</script>
